module.exports = __webpack_public_path__ + "static/trumpet_cn-007bd47dae93d6e4aa747e10908bf299.pdf";